/**
 * The XMLNodeType class contains constants used with
 * <codeph class="+ topic/ph pr-d/codeph ">XMLNode.nodeType</codeph>. The values are defined
 * by the NodeType enumeration in the
 * W3C DOM Level 1 recommendation:
 * <xref href="http://www.w3.org/TR/1998/REC-DOM-Level-1-19981001/level-one-core.html"
 * scope="external" class="- topic/xref ">http://www.w3.org/TR/1998/REC-DOM-Level-1-19981001/level-one-core.html</xref>
 * @langversion	3.0
 * @playerversion	Flash 9
 * @playerversion	Lite 4
 */
var XMLNodeType = /** @class */ (function () {
    function XMLNodeType() {
        // todo: why does this have a constructor ? it just provides static props...
    }
    //80pro todo: all values above 100 are value i assigned, maybe worth to check what they was in original as3
    XMLNodeType.CDATA_NODE = 100;
    XMLNodeType.COMMENT_NODE = 101;
    XMLNodeType.DOCUMENT_TYPE_NODE = 102;
    /**
     * Specifies that the node is an element.
     * This constant is used with XMLNode.nodeType.
     * The value is defined by the NodeType enumeration in the
     * W3C DOM Level 1 recommendation:
     * http://www.w3.org/TR/1998/REC-DOM-Level-1-19981001/level-one-core.html
     * @langversion	3.0
     * @playerversion	Flash 9
     * @playerversion	Lite 4
     */
    XMLNodeType.ELEMENT_NODE = 1;
    XMLNodeType.PROCESSING_INSTRUCTION_NODE = 103;
    /**
     * Specifies that the node is a text node.
     * This constant is used with XMLNode.nodeType.
     * The value is defined by the NodeType enumeration in the
     * W3C DOM Level 1 recommendation:
     * http://www.w3.org/TR/1998/REC-DOM-Level-1-19981001/level-one-core.html
     * @langversion	3.0
     * @playerversion	Flash 9
     * @playerversion	Lite 4
     */
    XMLNodeType.TEXT_NODE = 3;
    XMLNodeType.XML_DECLARATION = 104;
    return XMLNodeType;
}());
export { XMLNodeType };
